export enum PagesPaths {
  search = "/search",
  products = "/products/",
  categories = "/categories/",
  cart = "/cart",
  checkout = "/checkout",
  checkoutResult = "/checkout/result",

  confirmation = "/auth/confirmation",
  forget_password = "/auth/forget-password",
  register = "/auth/register",
  reset_password = "/auth/reset-password",
  register_confirm = "/auth/register-confirm",
  password_confirm = "/auth/password-confirm",
  signin = "/auth/signin",
  otp_signin = "/auth/otp-signin",

  address_book = "/user/address-book",
  orders = "/user/orders",
  appointments = "/user/appointments",
  consultations = "/user/consultations",
  profile = "/user/profile",
  userCheckout = "/user/checkout",
  students = "/user/students",
  agentsForms = "/user/agents-forms",
  program_progress = "/user/students/program-progress/",
  student_payments = "/user/students/student-payments",
  applications = "/user/students/applications",
  student_card = "/user/students/student-card/",

  blog = "/blog",
  blogDetails = "/blog/",

  aboutUs = "/about-us",
  notFound = "not-found",
}

// ============= outer search params =============
enum OuterSearchParams {
  force_item = "force_item",
}

export const forceItemInPage = (
  pagePath: PagesPaths,
  id: number | string | undefined,
) => `${pagePath}?${OuterSearchParams.force_item}=${id}`;

export const getInitialIdFromSearchParams = (searchParams: {
  [key: string]: string;
}) => {
  const force_item = searchParams[OuterSearchParams.force_item];
  return force_item ? +force_item : undefined;
};

export const removeOuterQueryParams = (params: URLSearchParams) => {
  Object.keys(OuterSearchParams).forEach((key) => {
    if (params.has(key)) params.delete(key);
  });
};
// =====================================
export const removeEmptyQueryParams = (params: URLSearchParams) => {
  for (const key of params.keys()) {
    if (params.get(key)?.trim() === "") params.delete(key);
  }
};
